// Check changes — the dialog shared by the Master Sheet and SAP Ship Doc (ChangeCheckDialog.jsx), in the portal's
// four languages (2026-10-21). {{noun}} is the screen's own word for what it compares ("sheet" / "document"),
// passed in already translated by MasterSheetChanges.jsx and 36_SapShipDoc.jsx.
const en = {
  title: 'Changes since your last check',
  comparing: 'Comparing the {{noun}} now ({{now}} rows) with the {{noun}} you marked as checked on <b>{{at}}</b> ({{then}} rows)',
  intro: 'Every new row, every row gone and every cell that moved, old value beside new',
  close: 'Close',
  firstTitle: 'This is your first check',
  firstBody: 'There is nothing to compare with yet. Save the {{noun}} as it stands now ({{n}} rows) as your starting point — from then on, Check changes lists everything that moved after it, whoever or whatever moved it.',
  chipChanged: 'Changed',
  chipNew: 'New',
  chipGone: 'Gone',
  rows_one: '{{n}} row',
  rows_other: '{{n}} rows',
  wordChanged: 'Changed',
  wordAdded: 'New row',
  wordRemoved: 'Row gone',
  nothingChanged: 'Nothing on the {{noun}} has changed since {{at}}.',
  cellsByColumn: 'Cells changed by column:',
  searchAria: 'Search the changes',
  clear: 'Clear',
  countOf: '{{shown}} of {{total}} rows',
  truncated: 'The list shows the first {{shown}} of {{total}} changed rows. Export Excel carries all of them.',
  colChange: 'Change',
  colWhat: 'What changed',
  colWhere: 'Where from',
  showMore: 'Show {{n}} more',
  compareWith: 'Compare with',
  myLastCheck: 'my last check — {{at}}',
  earlierCheck: 'an earlier check — {{at}}',
  checkAgain: 'Check again',
  building: 'Building…',
  exportExcel: 'Export Excel',
  markHint: 'What you see now becomes your starting point for the next check',
  marked: 'Marked as checked',
  mark: 'Mark as checked',
  savedShort: 'Saved',
  saveStart: 'Save as my starting point',
  savedNext: 'Saved. Your next check will compare against the {{noun}} as of {{at}}.',
  checkFailed: 'Check failed ({{status}})',
  saveFailed: 'Could not save ({{status}})',
  exportFailed: 'Export failed ({{status}})',
};

const ko = {
  title: '마지막 확인 이후 변경 사항',
  comparing: '현재 {{noun}}({{now}}행)를 <b>{{at}}</b>에 확인 완료로 표시한 {{noun}}({{then}}행)와 비교하고 있습니다',
  intro: '새로 생긴 행, 사라진 행, 값이 바뀐 셀을 모두 보여 주며, 이전 값과 새 값을 나란히 표시합니다',
  close: '닫기',
  firstTitle: '첫 번째 확인입니다',
  firstBody: '아직 비교할 기준이 없습니다. 현재 상태의 {{noun}}({{n}}행)를 시작점으로 저장하세요 — 그 이후로 변경 사항 확인은 그 시점 이후 바뀐 모든 것을, 누가 또는 무엇이 바꿨든 보여 줍니다.',
  chipChanged: '변경',
  chipNew: '신규',
  chipGone: '삭제',
  rows_one: '{{n}}행',
  rows_other: '{{n}}행',
  wordChanged: '변경',
  wordAdded: '새 행',
  wordRemoved: '사라진 행',
  nothingChanged: '{{at}} 이후 {{noun}}에서 바뀐 것이 없습니다.',
  cellsByColumn: '열별 변경 셀:',
  searchAria: '변경 사항 검색',
  clear: '지우기',
  countOf: '{{total}}행 중 {{shown}}행',
  truncated: '목록에는 변경된 {{total}}행 중 처음 {{shown}}행만 표시됩니다. Excel 내보내기에는 모두 포함됩니다.',
  colChange: '변경',
  colWhat: '변경 내용',
  colWhere: '출처',
  showMore: '{{n}}개 더 보기',
  compareWith: '비교 기준',
  myLastCheck: '마지막 확인 — {{at}}',
  earlierCheck: '이전 확인 — {{at}}',
  checkAgain: '다시 확인',
  building: '생성 중…',
  exportExcel: 'Excel 내보내기',
  markHint: '지금 보이는 상태가 다음 확인의 시작점이 됩니다',
  marked: '확인 완료로 표시됨',
  mark: '확인 완료로 표시',
  savedShort: '저장됨',
  saveStart: '시작점으로 저장',
  savedNext: '저장했습니다. 다음 확인은 {{at}} 시점의 {{noun}}와 비교합니다.',
  checkFailed: '확인 실패 ({{status}})',
  saveFailed: '저장할 수 없습니다 ({{status}})',
  exportFailed: '내보내기 실패 ({{status}})',
};

const vi = {
  title: 'Thay đổi kể từ lần kiểm tra trước',
  comparing: 'Đang so sánh {{noun}} hiện tại ({{now}} dòng) với {{noun}} bạn đã đánh dấu đã kiểm tra lúc <b>{{at}}</b> ({{then}} dòng)',
  intro: 'Mọi dòng mới, mọi dòng đã mất và mọi ô đã thay đổi, giá trị cũ cạnh giá trị mới',
  close: 'Đóng',
  firstTitle: 'Đây là lần kiểm tra đầu tiên của bạn',
  firstBody: 'Chưa có gì để so sánh. Hãy lưu {{noun}} như hiện tại ({{n}} dòng) làm mốc bắt đầu — từ đó trở đi, Kiểm tra thay đổi sẽ liệt kê mọi thứ thay đổi sau mốc này, dù do ai hay do đâu.',
  chipChanged: 'Đã đổi',
  chipNew: 'Mới',
  chipGone: 'Đã mất',
  rows_one: '{{n}} dòng',
  rows_other: '{{n}} dòng',
  wordChanged: 'Đã đổi',
  wordAdded: 'Dòng mới',
  wordRemoved: 'Dòng đã mất',
  nothingChanged: 'Không có gì trên {{noun}} thay đổi kể từ {{at}}.',
  cellsByColumn: 'Số ô thay đổi theo cột:',
  searchAria: 'Tìm trong các thay đổi',
  clear: 'Bỏ lọc',
  countOf: '{{shown}} / {{total}} dòng',
  truncated: 'Danh sách hiển thị {{shown}} dòng đầu trong {{total}} dòng thay đổi. File Xuất Excel có đủ tất cả.',
  colChange: 'Thay đổi',
  colWhat: 'Nội dung thay đổi',
  colWhere: 'Nguồn',
  showMore: 'Hiện thêm {{n}}',
  compareWith: 'So sánh với',
  myLastCheck: 'lần kiểm tra gần nhất — {{at}}',
  earlierCheck: 'một lần kiểm tra trước đó — {{at}}',
  checkAgain: 'Kiểm tra lại',
  building: 'Đang tạo…',
  exportExcel: 'Xuất Excel',
  markHint: 'Những gì bạn đang thấy sẽ là mốc bắt đầu cho lần kiểm tra sau',
  marked: 'Đã đánh dấu đã kiểm tra',
  mark: 'Đánh dấu đã kiểm tra',
  savedShort: 'Đã lưu',
  saveStart: 'Lưu làm mốc bắt đầu',
  savedNext: 'Đã lưu. Lần kiểm tra sau sẽ so sánh với {{noun}} tại thời điểm {{at}}.',
  checkFailed: 'Kiểm tra thất bại ({{status}})',
  saveFailed: 'Không lưu được ({{status}})',
  exportFailed: 'Xuất file thất bại ({{status}})',
};

const zh = {
  title: '自上次核对以来的变更',
  comparing: '正在将当前{{noun}}（{{now}} 行）与您于 <b>{{at}}</b> 标记为已核对的{{noun}}（{{then}} 行）进行比较',
  intro: '所有新增的行、消失的行以及变动的单元格，新旧值并列显示',
  close: '关闭',
  firstTitle: '这是您的第一次核对',
  firstBody: '目前还没有可比较的基准。请将当前的{{noun}}（{{n}} 行）保存为起点——此后，“检查变更”会列出在此之后发生的所有变动，无论由谁或由何引起。',
  chipChanged: '已变更',
  chipNew: '新增',
  chipGone: '已消失',
  rows_one: '{{n}} 行',
  rows_other: '{{n}} 行',
  wordChanged: '已变更',
  wordAdded: '新增行',
  wordRemoved: '行已消失',
  nothingChanged: '自 {{at}} 以来，{{noun}}上没有任何变更。',
  cellsByColumn: '按列统计的变更单元格：',
  searchAria: '搜索变更',
  clear: '清除',
  countOf: '{{shown}} / {{total}} 行',
  truncated: '列表仅显示 {{total}} 个变更行中的前 {{shown}} 行。导出 Excel 包含全部。',
  colChange: '变更',
  colWhat: '变更内容',
  colWhere: '来源',
  showMore: '再显示 {{n}} 行',
  compareWith: '比较对象',
  myLastCheck: '我的上次核对 — {{at}}',
  earlierCheck: '更早的一次核对 — {{at}}',
  checkAgain: '重新检查',
  building: '生成中…',
  exportExcel: '导出 Excel',
  markHint: '您现在看到的内容将成为下次核对的起点',
  marked: '已标记为已核对',
  mark: '标记为已核对',
  savedShort: '已保存',
  saveStart: '保存为我的起点',
  savedNext: '已保存。下次核对将与 {{at}} 时的{{noun}}进行比较。',
  checkFailed: '检查失败（{{status}}）',
  saveFailed: '无法保存（{{status}}）',
  exportFailed: '导出失败（{{status}}）',
};

const dictionary = { ns: 'xChange', en, ko, vi, zh };

export default dictionary;
